import angular from "angular";
import { configureStates, lazyLoad, lazyChild } from "../../core/router/router-helper.provider";
import { PayrollEntryRoutingModule } from "./payroll-entry/payroll-entry-routing.module";
import { PayStubRoutingModule } from "./pay-stub/pay-stub-routing.module";

const states = [
    {
        state: "payroll",
        config: {
            url: "/payroll",
            abstract: true
        }
    },
    {
        state: "payroll.manualRequest",
        config: {
            url: "/manuals",
            abstract: true
        }
    },
    {
        state: "payroll.manualRequest.**",
        config: {
            url: "/manuals",
            lazyLoad: lazyLoad(() => import("./manual-requests/payroll-manual-request.module")
                .then(p => p.PayrollManualRequestModule))
        }
    },
    {
        state: "payroll.payrollDashboard",
        config: {
            url: "/dashboard",
            component: "apexPayrollDashboard",
            resolve: {
                identity: employeeService => {
                    'ngInject';
                    return employeeService.retrieveIdentity();
                },
                employeeId: identity => {
                    'ngInject';
                    return identity.EmployeeID;
                }
            }
        }
    },
    // Define links to lazy routes.
    lazyChild("payroll.manualRequest.new", "/new"),
    lazyChild("payroll.manualRequest.list", "/list"),
    lazyChild("payroll.manualRequest.processing", "/processing"),
]

export const PayrollRoutingModule = angular
    .module("apex.mainApp.payroll.routing", [
        PayrollEntryRoutingModule,
        PayStubRoutingModule
    ])
    .run(configureStates(states))
    .name;
